import Swiper from 'swiper/bundle';
import simpleParallax from 'simple-parallax-js';

import 'slick-carousel';

export function idxFunc() {
  
  $('#jsMv').slick({
        accessibility: false,
        fade: true,
        autoplay: true,
        infinite: true,
        dots: true,
        arrows: false,
        autoplaySpeed: 5000,
        speed: 3000,
    });
  
  var topSwiper, topOptions;
  topSwiper = undefined;
  topOptions = {
    speed: 800,
    loop: true,
    slidesPerView: 2,
    spaceBetween: 6,
    initialSlide: 1,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
      invert: false
    },
    navigation: {
      nextEl: '.feePrev',
      prevEl: '.feeNext',
    },
    breakpoints: {
      769: {
        slidesPerView: 2.75,
        initialSlide: 1,
        spaceBetween: 20,
        centeredSlides: true
      }
    }
  };
  //スワイプ実行処理
  function initTopSwiper() {
    topSwiper = new Swiper('#jsFee', topOptions);
  }
  initTopSwiper();

  var support, supportOptions;
  support = undefined;
  supportOptions = {
    speed: 800,
    loop: true,
    slidesPerView: 2,
    spaceBetween: 6,
    initialSlide: 1,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
      invert: false
    },
    navigation: {
      nextEl: '.supportPrev',
      prevEl: '.supportNext',
    },
    breakpoints: {
      769: {
        slidesPerView: 2.75,
        initialSlide: 1,
        spaceBetween: 20,
        centeredSlides: true
      }
    }
  };
  //スワイプ実行処理
  function initSupportSwiper() {
    support = new Swiper('#supportFee', supportOptions);
  }
  initSupportSwiper();


  //パララックス

  var up = document.getElementsByClassName('pararaUp');
  var down = document.getElementsByClassName('pararaDown');
  var left = document.getElementsByClassName('pararaLeft');
  var right = document.getElementsByClassName('pararaRight');
  //let target = document.querySelectorAll('.parara1, .parara2');
  new simpleParallax(up, {
    delay: .6,
    scale: 1.125,
    transition: 'cubic-bezier(0,0,0,1)',
    orientation: 'up',
  });
  new simpleParallax(down, {
    delay: .6,
    orientation: 'down',
  });
  new simpleParallax(left, {
    delay: .6,
    orientation: 'left',
  });
  new simpleParallax(right, {
    delay: .6,
    orientation: 'right',
  });
}

//画面内に入ったら表示する系
export function scrEleFunc() {
  //トップページ
  $('.txtPos1').addClass('mvAni1');
  $('.txtPos2').addClass('mvAni1');
  
  $(window).on('load scroll', function () {
    
    var elem = $('.scrEle');
    var isAnimate = 'dispIn';
    elem.each(function () {
      var elemOffset = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();
      if (scrollPos > elemOffset - wh + (wh / 3)) {
        $(this).addClass(isAnimate);
      }
    });
    
    //テキストアニメーション
    var elem2 = $('.scrTxtBottom');
    var isAnimateTxt = 'txtAnDown';
    elem2.each(function () {
      var elemOffset2 = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();
      if (scrollPos > elemOffset2 - wh + (wh / 3)) {
        $(this).addClass(isAnimateTxt);
      }
    });
    
    //英語見出し
    
    //テキストアニメーション
    var elemEn = $('.scrTxtFlow');
    var isAnimateEn = 'aniEn';
    elemEn.each(function () {
      var elemOffset3 = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();
      if (scrollPos > elemOffset3 - wh + (wh / 9)) {
        $(this).addClass(isAnimateEn);
      }
    });
    
    //順番に表示
    var elemList = $('.scrEleList');
    var isAnimate = 'listIn';
    elemList.each(function () {
      var elemOffset = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();
      if (scrollPos > elemOffset - wh + (wh / 8)) {
        $(this).addClass(isAnimate);
      }
    });
  });
}